import React from "react";

import { ErrorBoundary } from "~/apps/shared/components/error-boundary/error-boundary";

import { AgencyNoticeHeaderBanner } from "../agency-notice-header-banner/agency-notice-header-banner";
import { styles } from "./agency-notices-orchestrator.styles";
import { useAgencyNoticesOrchestratorViewModel } from "./agency-notices-orchestrator.view-model";

const Component: React.FC = () => {
  const {
    handleCloseAgencyNoticeHeaderBanner,
    handleDismissAgencyNoticeHeaderBanner,
    headerBannerAgencyNotice,
    isAgencyNoticeHeaderBannerVisible,
    shouldShowLoading,
  } = useAgencyNoticesOrchestratorViewModel();

  if (shouldShowLoading) {
    return <div css={styles.root} />;
  }

  return (
    <>
      {headerBannerAgencyNotice && isAgencyNoticeHeaderBannerVisible ? (
        <AgencyNoticeHeaderBanner
          agencyNotice={headerBannerAgencyNotice}
          onClose={() => {
            handleCloseAgencyNoticeHeaderBanner();
          }}
          onDismiss={() => {
            handleDismissAgencyNoticeHeaderBanner(
              headerBannerAgencyNotice.token,
            );
          }}
        />
      ) : null}
    </>
  );
};

export const AgencyNoticesOrchestrator: React.FC = () => {
  return (
    <ErrorBoundary fallback={() => <></>}>
      <Component />
    </ErrorBoundary>
  );
};
